<template>
  <div class="login-index">
    <div class="tab-wrapper">
      <span
        v-for="(item, index) in innerTabs"
        :key="index"
        class="tab"
        :class="activeTab === item.id ? 'active' : ''"
        @click="activeTab = item.id"
      >
        {{ `${item.name}${$t('title.login')}` }}
      </span>
    </div>
    <!-- <div class="login" v-show="activeTab === 1000">
      <account-login />
    </div> -->
    <div class="login" v-show="activeTab === 1001">
      <phone-login />
    </div>
  </div>
</template>

<script>
import { computed, reactive, toRefs } from '@vue/composition-api';
import { LOGIN_TAB } from '@/constants/auth';
import PhoneLogin from './phone';

export default {
  name: 'LoginIndex',
  props: {
    systemInfo: {
      type: Object,

      default: () => {},
    },
  },
  components: { PhoneLogin },
  setup(props, context) {
    const { $store } = context.root;
    const state = reactive({
      activeTab: LOGIN_TAB.PHONE,
    });
    const innerTabs = computed(() => {
      const loginType = $store.state.enums?.LoginType || [];
      const phoneTab = loginType.find(item => item.id === LOGIN_TAB.PHONE);
      return phoneTab ? [phoneTab] : [];
    });
    return {
      ...toRefs(state),
      innerTabs,
    };
  },
};
</script>

<style lang="scss" scoped>
.login-index {
  min-height: 300px;

  .tab-wrapper {
    border-bottom: 1px solid #ddd;

    padding: 20px 40px 10px;

    .tab {
      cursor: pointer;

      margin-right: 30px;

      padding-bottom: 8px;

      &.active {
        color: #000;

        font-size: 18px;

        border-bottom: 3px solid var(--color-primary);
      }
    }
  }

  .login {
    margin-top: 40px;

    padding: 0 40px 30px;
  }
}
</style>
